<div class="modal__header">
  <div class="modal__title">
    REQUEST STATEMENTS
  </div>
  <div class="modal__close" (click)="popup.close();">
    <i class="fas fa-times"></i>
  </div>
</div>

<div class="modal__content">
  <form>
    <div class="row">
      <div class="col-xs-4">
        <div class="mt-0">
          <label for="periodType">
            Reporting Period
          </label>
          <select class="form-select" name="periodType" id="periodType" (change)="changePeriodType($event)">
            @for (periodType of periodTypes; track periodType) {
              <option [value]="periodType.key">
                {{periodType.value}}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="col-xs-8">
        <div class="mt-0">
          <label>
            How many periods are you requesting?
          </label>
          <br />
          <input id="one" name="period" type="radio" checked (change)="togglePeriodsRequested(false)" />
          <label for="one">&nbsp;One</label> &nbsp;&nbsp;
          <input id="multi" name="period" type="radio" (change)="togglePeriodsRequested(true)" /> <label for="multi">&nbsp;Multiple</label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-6">
        <div class="mt-3 mb-0" [hidden]="!oneMonth">
          <label>
            Period Date
          </label>
          <app-input-calendar-component fieldName="statementDate" [initialDate]="selectedStatementDate"
            (dateEmitter)="updateStatementDate($event)">
          </app-input-calendar-component>
        </div>
        <div class="mt-3 mb-0" [hidden]="!multiMonth">
          <label>
            From
          </label>
          <app-input-calendar-component fieldName="statementDate" [initialDate]="selectedStatementDateFrom"
            (dateEmitter)="updateStatementDate($event, true, true)">
          </app-input-calendar-component>
        </div>
      </div>
      <div class="col-xs-6">
        <div class="mt-3 mb-0" [hidden]="!multiMonth">
          <label>
            To
          </label>
          <app-input-calendar-component fieldName="statementDate" [initialDate]="selectedStatementDateTo"
            (dateEmitter)="updateStatementDate($event, true)">
          </app-input-calendar-component>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="mt-3 mb-0">
          <label>
            Statement Type
          </label>
          @for (document of uploadDocumentTypes; track document) {
            <div>
              <label>
                <input type="checkbox" (change)="onDocTypeClick(document['displayName'])">
                {{document['displayName']}}
              </label>
            </div>
          }
        </div>
      </div>
    </div>

    @for (otherDoc of otherDocs; track otherDoc) {
      <div class="row">
        <div class="col-xs-12">
          <div class="input-group inline">
            <input type="checkbox" id="otherCheckbox" [(ngModel)]="otherDoc.checked" [ngModelOptions]="{standalone: true}"
              (click)="addInput(this.otherDoc.text, this.otherDoc.checked)" />
            <input type="text" id="otherDocType" [(ngModel)]="otherDoc.text" [ngModelOptions]="{standalone: true}"
              class="form-control" placeholder="Other doc type" (change)="onDocTypeClick(this.otherDoc.text, true, this.otherDoc.checked)" />
          </div>
        </div>
      </div>
    }
  </form>
</div>

<div class="modal__footer">
  <button type="reset" class="btn btn-link" (click)="popup.close();">Close</button>
  <button type="submit" class="btn btn-primary" (click)="generateLink();">Generate Link</button>
</div>
